<template>
  <header class="site-header">
    <div class="container">
      <div class="header-content">
        <div class="logo">
          <router-link to="/">
            <img src="../assets/logo.png" alt="FM Logo">
            <span class="site-title">Radio App - FM Radio Stations</span>
          </router-link>
        </div>
        
        <!-- 汉堡菜单按钮 -->
        <div class="hamburger" :class="{ active: menuOpen }" @click="toggleMenu">
          <span></span>
          <span></span>
          <span></span>
        </div>

        <!-- 导航菜单 -->
        <nav class="main-nav" :class="{ 'mobile-open': menuOpen }">
          <ul>
            <li><router-link to="/" @click="closeMenu">Home</router-link></li>
            <li><a href="/#features" @click="closeMenu">Features</a></li>
            <li><a href="/#image-carousel" @click="closeMenu">Showcase</a></li>
            <li><a href="/#download" @click="closeMenu">Download</a></li>
            <li><a href="mailto:sl9283191@gmail.com" @click="closeMenu">Contact Us</a></li>
          </ul>
        </nav>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'SiteHeader',
  data() {
    return {
      menuOpen: false
    }
  },
  methods: {
    toggleMenu() {
      this.menuOpen = !this.menuOpen
      document.body.style.overflow = this.menuOpen ? 'hidden' : ''
    },
    closeMenu() {
      this.menuOpen = false
      document.body.style.overflow = ''
    }
  }
}
</script>

<style scoped>
:root {
  --primary-color: #4a86e8; /* 明亮的蓝色 */
  --primary-dark: #3367d6; /* 深蓝色 */
  --primary-light: #7dabf5; /* 浅蓝色 */
  --text-dark: #333333;
  --text-light: #ffffff;
  --bg-light: #f5f8ff; /* 浅蓝背景 */
}

.site-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.98), rgba(255, 255, 255, 0.95));
  backdrop-filter: blur(10px);
  z-index: 1000;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
  border-bottom: 1px solid rgba(74, 134, 232, 0.08);
}

.site-header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100%;
  background: 
    radial-gradient(circle at 0% 0%, rgba(74, 134, 232, 0.03) 0%, transparent 50%),
    radial-gradient(circle at 100% 0%, rgba(125, 171, 245, 0.03) 0%, transparent 50%);
  pointer-events: none;
}

.site-header::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(90deg, 
    transparent,
    rgba(74, 134, 232, 0.1),
    rgba(125, 171, 245, 0.1),
    transparent
  );
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
  position: relative;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 70px;
}

.logo {
  position: relative;
  z-index: 2;
}

.logo a {
  display: flex;
  align-items: center;
  text-decoration: none;
}

.logo img {
  height: 40px;
  margin-right: 10px;
  transition: transform 0.3s ease;
}

.logo:hover img {
  transform: scale(1.05);
}

.site-title {
  font-size: 18px;
  font-weight: 700;
  color: var(--primary-color);
  background: linear-gradient(90deg, var(--primary-color), var(--primary-light));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.main-nav ul {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  gap: 30px;
}

.main-nav a {
  color: #333;
  text-decoration: none;
  font-weight: 500;
  font-size: 16px;
  transition: all 0.3s;
  position: relative;
  padding: 5px 0;
}

.main-nav a::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 2px;
  background: linear-gradient(90deg, var(--primary-color), var(--primary-light));
  transition: width 0.3s ease;
  border-radius: 2px;
}

.main-nav a:hover {
  color: var(--primary-color);
  transform: translateY(-1px);
}

.main-nav a:hover::after {
  width: 100%;
}

.main-nav a.router-link-active {
  color: var(--primary-color);
}

.main-nav a.router-link-active::after {
  width: 100%;
}

/* 汉堡菜单样式 */
.hamburger {
  display: none;
  width: 30px;
  height: 24px;
  position: relative;
  cursor: pointer;
  z-index: 1001;
}

.hamburger span {
  display: block;
  position: absolute;
  height: 3px;
  width: 100%;
  background: var(--primary-color);
  border-radius: 3px;
  opacity: 1;
  left: 0;
  transform: rotate(0deg);
  transition: .3s ease-in-out;
}

.hamburger span:nth-child(1) {
  top: 0px;
}

.hamburger span:nth-child(2) {
  top: 10px;
}

.hamburger span:nth-child(3) {
  top: 20px;
}

.hamburger.active span:nth-child(1) {
  top: 10px;
  transform: rotate(45deg);
}

.hamburger.active span:nth-child(2) {
  opacity: 0;
}

.hamburger.active span:nth-child(3) {
  top: 10px;
  transform: rotate(-45deg);
}

@media (max-width: 768px) {
  .hamburger {
    display: block;
  }

  .main-nav {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100vh;
    background: rgba(255, 255, 255, 0.98);
    backdrop-filter: blur(10px);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    opacity: 0;
    visibility: hidden;
    transform: translateY(-20px);
    transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  }

  .main-nav.mobile-open {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
  }

  .main-nav ul {
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }

  .main-nav a {
    font-size: 20px;
    padding: 10px 0;
  }

  .site-header {
    background: rgba(255, 255, 255, 0.98);
  }

  .site-title {
    font-size: 16px;
  }
}
</style> 